
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/urban-heat-equity",
      function () {
        return require("private-next-pages/stories/urban-heat-equity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/urban-heat-equity"])
      });
    }
  